import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { MapPin, Wrench, ArrowRight } from "@phosphor-icons/react";

const projects = [
  {
    image:
      "https://customer-assets.emergentagent.com/job_habitat-vert/artifacts/wo31heqs_IMG_3223.jpeg",
    title: "Pompe à chaleur air/eau",
    location: "Maison individuelle – 94",
    work: "Installation complète + ballon thermique",
  },
  {
    image:
      "https://customer-assets.emergentagent.com/job_habitat-vert/artifacts/2ap815ww_IMG_3224.jpeg",
    title: "Chauffe-eau thermodynamique",
    location: "Pavillon – Île-de-France",
    work: "Remplacement ancien système",
  },
  {
    image:
      "https://customer-assets.emergentagent.com/job_habitat-vert/artifacts/iekgxgu6_IMG_3225.jpeg",
    title: "Installation complète chauffage",
    location: "Maison – 91",
    work: "PAC + réseau hydraulique",
  },
  {
    image:
      "https://customer-assets.emergentagent.com/job_habitat-vert/artifacts/28l6jsz6_IMG_3227.jpeg",
    title: "Optimisation système énergétique",
    location: "Maison ancienne – Île-de-France",
    work: "Mise aux normes + amélioration performance",
  },
];

export default function Realisations() {
  return (
    <section
      id="realisations"
      data-testid="realisations-section"
      className="py-20 lg:py-28 bg-white"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mb-12">
          <div className="text-xs font-bold uppercase tracking-[0.2em] text-emerald-700 mb-3">
            Nos réalisations récentes
          </div>
          <h2 className="font-heading text-3xl sm:text-4xl font-bold text-slate-900">
            Des installations concrètes, réalisées chez nos clients
          </h2>
          <p
            data-testid="realisations-social-proof"
            className="text-slate-900 mt-4 text-base md:text-lg font-semibold"
          >
            Plus de 250 installations réalisées et clients accompagnés en 2025.
          </p>
          <p className="text-slate-600 mt-2 text-base md:text-lg leading-relaxed">
            Un aperçu de projets menés en Île-de-France : pompes à chaleur,
            chauffe-eau thermodynamiques et optimisations complètes de systèmes
            de chauffage.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {projects.map((p, i) => (
            <motion.article
              key={p.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.2 }}
              transition={{ duration: 0.4, delay: i * 0.08 }}
              data-testid={`realisation-${i}`}
              className="group bg-white rounded-2xl overflow-hidden border border-slate-200 shadow-[0_8px_30px_rgba(0,0,0,0.04)] hover:shadow-[0_20px_40px_rgba(30,64,175,0.12)] hover:border-blue-300 transition-all"
            >
              <div className="relative aspect-[4/3] overflow-hidden bg-slate-100">
                <img
                  src={p.image}
                  alt={p.title}
                  loading="lazy"
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-slate-900/30 via-transparent to-transparent" />
              </div>
              <div className="p-5">
                <h3 className="font-heading font-semibold text-slate-900 text-base md:text-lg mb-3 leading-snug">
                  {p.title}
                </h3>
                <div className="space-y-2 text-sm text-slate-600">
                  <div className="flex items-start gap-2">
                    <MapPin
                      size={16}
                      weight="fill"
                      className="text-blue-700 flex-shrink-0 mt-0.5"
                    />
                    <span>{p.location}</span>
                  </div>
                  <div className="flex items-start gap-2">
                    <Wrench
                      size={16}
                      weight="fill"
                      className="text-emerald-600 flex-shrink-0 mt-0.5"
                    />
                    <span>{p.work}</span>
                  </div>
                </div>
              </div>
            </motion.article>
          ))}
        </div>

        <div className="text-center mt-12">
          <Link
            to="/eligibilite"
            data-testid="realisations-eligibility-btn"
            className="inline-flex items-center gap-2 px-6 py-4 rounded-xl font-semibold btn-primary-eco"
          >
            Tester mon éligibilité gratuitement <ArrowRight size={18} weight="bold" />
          </Link>
          <p className="text-sm text-slate-700 mt-3 font-medium">
            Réponse rapide sous 24h – étude gratuite et sans engagement
          </p>
          <p className="text-xs text-slate-500 mt-1">
            Étude personnalisée. Aides disponibles selon votre situation.
          </p>
        </div>
      </div>
    </section>
  );
}
